// removed by extract-text-webpack-plugin
module.exports = {"popover":"popover--BEabJ"};